import _ from 'lodash';
import { create } from 'zustand';

export const fetch = async (service, method, params, setters) => {
	let result;
	if (_.isArray(params)) {
		result = await service[method](...params);
	}
	else {
		result = await service[method](params);
	}

	setters = _.isArray(setters) ? setters : [setters];
	await _.forEach(setters, async (setter) => {
		if (_.isFunction(setter)) {
			await setter(result.data.data);
		}
		else {
			throw new Error('not supported anymore');
		}
	});

	return result.data.data;
};

const setItem = (state, singleKey, pluralKey, item) => {
	const result = saveItem(state, pluralKey, item);
	if (!_.isEqual(state[singleKey], item)) {
		result[singleKey] = item;
	}
	return result;
};

const saveItem = (state, key, item) => {
	if (!item?.id) {
		return {};
	}
	const arr = !state[key] ? [] : [...state[key]];
	const existingIndex = _.findIndex(arr, { id: item.id });
	if (existingIndex >= 0) {
		const existing = arr[existingIndex];
		if (_.isEqual(existing, item)) {
			return {};
		}
		arr.splice(existingIndex, 1, _.merge(arr[existingIndex], item));
	}
	else {
		arr.push(item);
	}
	return { [key]: arr };
}

const deleteItem = (state, key, id) => {
	if (!state[key]) {
		return state;
	}
	const arr = [...state[key]];
	const existingIndex = _.findIndex(arr, { id });
	if (existingIndex >= 0) {
		arr.splice(existingIndex, 1);
	}
	return { [key]: arr };
}

export const useAppStore = create((set, get) => ({
	// Actions
	fetch: fetch,
	save: (model, item) => set((state) => saveItem(state, model, item)),
	delete: (model, id) => set((state) => deleteItem(state, model, id)),

	users: [],
	user: {},
	getUsers: () => get().users,
	getUser: (id) => _.find(get().users, { id }),
	setUser: (newUser) => { set((state) => setItem(state, 'user', 'users', newUser)); return newUser; },
	setUsers: (newUsers) => set((state) => ({ users: newUsers })),
	saveUser: (user) => set((state) => saveItem(state, 'users', user)),
	deleteUser: (user) => set((state) => deleteItem(state, 'users', user)),

	schools: [],
	school: {},
	getSchools: () => get().schools,
	getSchool: (id) => _.find(get().schools, { id }),
	setSchool: (newSchool) => { set((state) => setItem(state, 'school', 'schools', newSchool)); return newSchool; },
	setSchools: (newSchools) => set((state) => ({ schools: newSchools })),
	saveSchool: (school) => set((state) => saveItem(state, 'schools', school)),
	deleteSchool: (school) => set((state) => deleteItem(state, 'schools', school)),

	todos: [],
	todo: {},
	getTodos: () => get().todos,
	getTodo: (id) => _.find(get().todos, { id }),
	setTodo: (newTodo) => { set((state) => setItem(state, 'todo', 'todos', newTodo)); return newTodo; },
	setTodos: (newTodos) => set((state) => ({ todos: newTodos })),
	saveTodo: (todo) => set((state) => saveItem(state, 'todos', todo)),
	deleteTodo: (todo) => set((state) => deleteItem(state, 'todos', todo)),
}));

export const useSnackbarStore = create((set) => ({
	message: null,
	severity: "info",
	show: (message, severity = "info") => set({ message, severity }),
	clear: () => set({ message: null }),
}));